

























import Vue from 'vue'
import { ActionInterface, BlockStatus2ElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'BlockStatus2El',
  props: {
    templateItemData: {
      type: Object as () => BlockStatus2ElInterface,
      required: true
    }
  },
  methods: {
    handleActionClick (action: ActionInterface): void {
      if (action.uri !== undefined) {
        this.getView(action.view, action.content || action.uri, null, action.jumpOnCloseUri)
      }
    }
  },
  computed: {
    mainStyle (): string {
      return 'background: ' + this.templateItemData.background + '; border-radius: 10px;'
    },
    textStyle (): string {
      return 'color: ' + this.templateItemData.textColor + ';'
    },
    priceStyle (): string {
      return 'background: ' + this.templateItemData.priceHighlight + ';'
    }
  }
})
